import { useState } from 'react';
import {
  Box, Button, Dialog, DialogTitle, DialogContent,
  DialogActions, TextField, InputAdornment, IconButton,
  Typography, Tooltip,
} from '@mui/material';
import LinkIcon        from '@mui/icons-material/Link';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import CheckIcon       from '@mui/icons-material/Check';
import PersonAddIcon   from '@mui/icons-material/PersonAdd';

import { UserTable } from '../../components/user';
import { PageHeader } from '../../components/shared';
import { useAuthContext } from '../../context/auth-context';

import styled from 'styled-components';

const Root = styled.div`
  margin-top: 2%;
`;

export const UserPage = () => {
  const { activeCamp, hasPermission } = useAuthContext();
  const [dialogOpen, setDialogOpen] = useState(false);
  const [copied, setCopied]         = useState(false);

  const inviteUrl = `${window.location.origin}/invite/${activeCamp?._id}`;

  const handleCopy = () => {
    navigator.clipboard.writeText(inviteUrl).then(() => {
      setCopied(true);
      setTimeout(() => setCopied(false), 2500);
    });
  };

  return (
    <Root>
      <Box sx={{ display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between', flexWrap: 'wrap', gap: 1 }}>
        <PageHeader title="Usuarios" />
        {/* El enlace lleva a un registro público: solo lo reparte quien puede dar de alta. */}
        {hasPermission('users.manage') && (
          <Button
            variant="contained"
            startIcon={<PersonAddIcon />}
            onClick={() => setDialogOpen(true)}
            disabled={!activeCamp}
            sx={{
              backgroundColor: '#284B32',
              '&:hover': { backgroundColor: '#203c27' },
              textTransform: 'none',
              fontWeight: 600,
              borderRadius: 2,
              mt: 0.5,
            }}
          >
            Invitar a Juez
          </Button>
        )}
      </Box>

      <UserTable />

      <Dialog open={dialogOpen} onClose={() => setDialogOpen(false)} maxWidth="sm" fullWidth
        PaperProps={{ sx: { borderRadius: 2 } }}>
        <DialogTitle sx={{ pb: 1 }}>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
            <LinkIcon sx={{ color: '#284B32' }} />
            Invitar a Juez
          </Box>
        </DialogTitle>
        <DialogContent>
          <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
            Comparte este enlace con el juez. Al abrirlo podrá registrarse o iniciar
            sesión para unirse a <strong>{activeCamp?.name}</strong>.
          </Typography>
          <TextField
            value={inviteUrl}
            fullWidth
            size="small"
            InputProps={{
              readOnly: true,
              endAdornment: (
                <InputAdornment position="end">
                  <Tooltip title={copied ? '¡Copiado!' : 'Copiar enlace'}>
                    <IconButton onClick={handleCopy} edge="end" size="small">
                      {copied ? <CheckIcon fontSize="small" sx={{ color: '#284B32' }} /> : <ContentCopyIcon fontSize="small" />}
                    </IconButton>
                  </Tooltip>
                </InputAdornment>
              ),
              sx: { fontFamily: 'monospace', fontSize: '0.8rem' },
            }}
          />
        </DialogContent>
        <DialogActions sx={{ px: 3, pb: 2 }}>
          <Button onClick={() => setDialogOpen(false)} sx={{ color: 'text.secondary', textTransform: 'none' }}>
            Cerrar
          </Button>
          <Button
            variant="contained"
            onClick={handleCopy}
            startIcon={copied ? <CheckIcon /> : <ContentCopyIcon />}
            sx={{
              backgroundColor: '#284B32', '&:hover': { backgroundColor: '#203c27' },
              textTransform: 'none',
            }}
          >
            {copied ? '¡Copiado!' : 'Copiar enlace'}
          </Button>
        </DialogActions>
      </Dialog>
    </Root>
  );
};
